import { CalendarComponent } from "@forwardflow/components/Calendar";
import { DashboardContainer } from "@forwardflow/components/Dashboard";

const Calender = () => {
   return (
      <DashboardContainer>
         <CalendarComponent />
      </DashboardContainer>
   );
};

export default Calender;
